export default "__VITE_ASSET__b34fd97b__"